import type {ConnectionOperation, EntityOperation} from '@github-ui/optimistic-connection'
import type {IssueViewerSecondaryViewServerQueryQuery} from '@github-ui/server-persisted-queries/types/IssueViewerSecondaryViewServerQuery'

import type {SubIssuesListItemNode} from '../components/sub-issues-list-item-query-types'

export const SUB_ISSUES_CONNECTION_PATH = ['subIssues']

type IssueNode = NonNullable<NonNullable<IssueViewerSecondaryViewServerQueryQuery['repository']>['issue']>

export type SubIssueParentData = Pick<
  IssueNode,
  'id' | 'number' | 'state' | 'stateReason' | 'subIssuesSummary' | 'title' | 'titleHTML' | 'url'
> & {
  readonly repository: Pick<IssueNode['repository'], 'name' | 'nameWithOwner'> & {
    readonly owner: Pick<IssueNode['repository']['owner'], 'login'>
  }
}

export function subIssuesMutationScopeId(parentIssueId: string): string {
  return `sub-issues:${parentIssueId}`
}

export function buildAddSubIssueOperation(node: SubIssuesListItemNode): ConnectionOperation {
  return {
    type: 'addToConnection',
    connectionPath: SUB_ISSUES_CONNECTION_PATH,
    node,
    anchor: {at: 'end'},
    counts: [
      {path: ['subIssuesSummary', 'total'], delta: 1},
      {path: ['subIssuesConnection', 'totalCount'], delta: 1},
      ...(node.closed ? [{path: ['subIssuesSummary', 'completed'], delta: 1}] : []),
    ],
  }
}

export function buildRemoveSubIssueOperation(subIssueId: string, closed: boolean): ConnectionOperation {
  return {
    type: 'removeFromConnection',
    connectionPath: SUB_ISSUES_CONNECTION_PATH,
    nodeId: subIssueId,
    counts: [
      {path: ['subIssuesSummary', 'total'], delta: -1},
      {path: ['subIssuesConnection', 'totalCount'], delta: -1},
      ...(closed ? [{path: ['subIssuesSummary', 'completed'], delta: -1}] : []),
    ],
  }
}

export function buildConfirmedSubIssuesSummaryOperation(
  parentIssueId: string,
  summary: {total: number; completed: number},
): EntityOperation {
  return {type: 'setFields', id: parentIssueId, fields: {subIssuesSummary: summary}}
}

export function buildSubIssueParentOperation(
  subIssueId: string,
  parent: SubIssueParentData | {id: string} | null,
): EntityOperation {
  return {type: 'setFields', id: subIssueId, fields: {parent}}
}
